"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var colors_1 = require("./colors");

var paginationVariants = {
  default: {
    color: colors_1.DarkColors.textColor,
    activeColor: colors_1.DarkColors.textColor,
    borderColor: colors_1.DarkColors.baseOffset,
    activeBorderColor: colors_1.DarkColors.baseOffset,
    backgroundHoverColor: colors_1.DarkColors.baseOffset,
    borderHoverColor: colors_1.DarkColors.baseOffsetLighter,
    backgroundColor: colors_1.DarkColors.base,
    activeBackgroundColor: colors_1.DarkColors.primary,
    borderRadius: 8
  }
};
var cardVariants = {
  default: {
    backgroundColor: colors_1.DarkColors.base,
    color: colors_1.DarkColors.textColor,
    borderColor: colors_1.DarkColors.baseOffsetLighter,
    borderRadius: 4
  }
};
exports.default = {
  cardVariants: cardVariants,
  paginationVariants: paginationVariants
};